import { ActionResponseStatus } from '@/core/interfaces/common';

/**
 * What kind of conversion a 2xx submission was. Every 2xx submission is a
 * conversion (the person converted as a lead); the outcome only segments it.
 *
 *   action_taken — targets matched, or a signup form / petition submission
 *   no_targets   — 200 with status 'error': the address matched no targets,
 *                  but the backend still saved the contact
 *   test         — 200 with status 'test' from an action center in test mode
 *
 * Non-2xx responses are not conversions and have no outcome.
 */
export type SubmitOutcome = 'action_taken' | 'no_targets' | 'test';

export const getSubmitOutcome = (status: string | undefined): SubmitOutcome => {
  if (status === ActionResponseStatus.test) {
    return 'test';
  }

  if (status === 'error') {
    return 'no_targets';
  }

  return 'action_taken';
};
